import { ColumnType } from "antd/es/table/interface";

import { SurveyAdminResponse } from "@/redux/survey/types";
import { RowSelectionProps } from "@/components_v2/Tables/types";
import { SimpleModalProps } from "@/components_v2/Modal/types";

export const SUBMISSION_TIMING = {
  BEFORE_SOFT_DEADLINE: "beforeSoftDeadline",
  AFTER_SOFT_DEADLINE: "afterSoftDeadline",
} as const;

export type SubmissionTiming =
  (typeof SUBMISSION_TIMING)[keyof typeof SUBMISSION_TIMING];

export interface SurveyStatisticsFiltersState {
  search?: string;
  isSurveyStarted?: boolean;
  isSubmissionRequired?: boolean;
  isSubmitted?: boolean;
  submissionTiming?: SubmissionTiming;
  survey?: number;
}

export interface SurveyStatisticsFiltersProps {
  filterNames: (keyof SurveyStatisticsFiltersState)[];
  setFilters: (filters: Partial<SurveyStatisticsFiltersState>) => void;
  defaultFilters?: Partial<SurveyStatisticsFiltersState>;
}

export interface SurveyStatisticsTableProps<T> extends RowSelectionProps {
  columnNames: string[];
  defaultFilters?: Partial<SurveyStatisticsFiltersState> & {
    organization?: number;
  };
  filterNames: (keyof SurveyStatisticsFiltersState)[];
  additionalColumns?: Record<string, ColumnType<T>>;
  className?: string;
  filtersCallback?: (filters: Partial<SurveyStatisticsFiltersState>) => void;
  softDeadline?: string | null;
}

export interface SurveyManagementProps {
  survey: SurveyAdminResponse;
}

export interface SurveyInvitesModalProps extends SimpleModalProps {
  survey: SurveyAdminResponse;
}
